import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M18.1315 18H5.86852C5.06982 18 4.59343 17.1099 5.03647 16.4453L7.49391 12.7591C7.7806 12.3291 8.34778 12.1884 8.80224 12.4345L9.99449 13.0803C10.4373 13.3202 10.9894 13.1933 11.2831 12.7843L13.1572 10.1739C13.5647 9.60624 14.414 9.62096 14.8016 10.2024L18.9635 16.4453C19.4066 17.1099 18.9302 18 18.1315 18Z",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      d: "M9.5 9C10.3284 9 11 8.32843 11 7.5C11 6.67157 10.3284 6 9.5 6C8.67157 6 8 6.67157 8 7.5C8 8.32843 8.67157 9 9.5 9Z",
      fill: "white"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M0 3C0 1.34314 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34314 24 0 22.6569 0 21V3ZM3 2C2.44771 2 2 2.44772 2 3V21C2 21.5523 2.44772 22 3 22H21C21.5523 22 22 21.5523 22 21V3C22 2.44771 21.5523 2 21 2H3Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }